module.exports = __webpack_public_path__ + "img/template27.e670af84.png";